import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { UseDataUserProvider } from './_Hooks/_Context/useDataUserAuthenticated';
import { NotificationsProvider } from 'reapop';
import { ChakraProvider, ColorModeScript } from '@chakra-ui/react';
import { QueryClient, QueryClientProvider } from 'react-query';
import theme from './theme';
// ↑ Puedes usar "ColorModeScript" si quieres que Chakra recuerde el modo seleccionado

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);
const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <NotificationsProvider>
      <UseDataUserProvider>
        <QueryClientProvider client={queryClient}>
          {/* Envuelve todo en ChakraProvider */}
          <ChakraProvider theme={theme}>
            {/*
              Opcional: <ColorModeScript />
              Esto permite que Chakra recuerde el modo 
              y cargue el preferido al recargar la página.
            */}
            <ColorModeScript initialColorMode={theme.config.initialColorMode} />
            <App />
          </ChakraProvider>
        </QueryClientProvider>
      </UseDataUserProvider>
    </NotificationsProvider>
  </React.StrictMode>
);
